import { ItinerantDetailTemplate } from "../../Templates/ItinerantDetailTemplate";

export const ItinerantDetail = () => {
  return <ItinerantDetailTemplate />;
};
